import React from 'react';
import { Link } from 'gatsby';
import { getResponsiveImageLink } from '../../utils/getResponsiveImageLink';

const Footer = () => {
	const date = new Date();
	return (
		<>
			<footer className="text-white bg-black">
				<div className="container flex flex-col pt-16 space-y-5 md:space-y-0 md:space-x-20 md:flex-row pb-14">
					<div className="flex-shrink-0">
						<img
							width={215}
							height={100}
							className="mb-6"
							loading="lazy"
							src={getResponsiveImageLink('images/svg/logo-green.svg', 215, null)}
							alt="Logo"
						/>
					</div>
					<div className="flex-1">
						<p className="mb-6 font-semibold">Integrations</p>
						<div className="flex flex-col md:flex-row md:space-x-10">
							<div className="flex flex-col space-y-2">
								<Link
									to="/integrations/xero/"
									className="transition-colors hover:text-green"
								>
									Cash Flow Frog for Xero
								</Link>
								<Link
									to="/integrations/freshbooks/"
									className="transition-colors hover:text-green"
								>
									Cash Flow Frog for FreshBooks
								</Link>
								<Link
									to="/integrations/excel/"
									className="transition-colors hover:text-green"
								>
									Cash Flow Frog for Excel
								</Link>
							</div>
							<div className="flex flex-col space-y-2">
								<Link
									to="/integrations/quickbooks-online/"
									className="transition-colors hover:text-green"
								>
									Cash Flow Frog for QuickBooks Online
								</Link>
								<Link
									to="/integrations/quickbooks-desktop/"
									className="transition-colors hover:text-green"
								>
									Cash Flow Frog for QuickBooks Desktop
								</Link>
								<Link
									to="/integrations/sage-intacct/"
									className="transition-colors hover:text-green"
								>
									Cash Flow Frog for Sage Intacct
								</Link>
							</div>
						</div>
					</div>
					<div>
						<p className="mb-6 font-semibold">Resources</p>
						<div className="flex flex-col space-y-2">
							<Link to="/blog/" className="transition-colors hover:text-green">
								Blog
							</Link>
							<Link to="/whats-new/" className="transition-colors hover:text-green">
								Whats new
							</Link>
							<a
								href="https://help.cashflowfrog.com/en"
								target="_blank"
								rel="noreferrer"
								className="transition-colors hover:text-green"
							>
								Help & Support
							</a>
							<Link to="/about-us/" className="transition-colors hover:text-green">
								About us
							</Link>
							<Link to="/contact/" className="transition-colors hover:text-green">
								Contact us
							</Link>
						</div>
					</div>
				</div>
				<div className="container border-t border-[#343536] flex flex-col md:flex-row justify-between text-xs py-5">
					<p>© Cash Flow Frog {date.getFullYear()}. All Rights Reserved.</p>
					<div className="space-x-5">
						<Link
							to="/terms-conditions/"
							className="transition-colors hover:text-green"
						>
							Terms & Conditions
						</Link>
						<Link to="/privacy-policy/" className="transition-colors hover:text-green">
							Privacy Policy
						</Link>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
